import { Account } from 'api/account/types'
import { graphql } from 'msw'
import db from '../db'

const accountHandlers = [
  graphql.query('queryAccount', (req, res, ctx) => {
    const account = db.account.get('1')

    return res(ctx.data({ account }))
  }),

  graphql.mutation('crateAccount', (req, res, ctx) => {
    const account = db.account.create(req.variables as Account)
    return res(ctx.data({ accountCreate: { account } }))
  }),

  graphql.mutation('updateAccount', (req, res, ctx) => {
    const account = db.account.update(req.variables as Account)
    return res(ctx.data({ accountUpdate: { account } }))
  }),
]

export default accountHandlers
